import { render, staticRenderFns } from "./CancelDocDialog.vue?vue&type=template&id=038e8378&"
import script from "./CancelDocDialog.vue?vue&type=script&lang=js&"
export * from "./CancelDocDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports